import React from 'react';

/** CONFIGURATION */
const LOADING_SKELETON_CLASS = 'loading-skeleton';

export default function SearchPageSidebarSkeleton() {
    return (
        <div
            style={{
                display: 'flex',
                justifyContent:'space-between',
                alignItems: 'center',
                marginTop: '2em',
            }}
        >
            <div>
                {/* Price range */}
                <div
                    className={LOADING_SKELETON_CLASS}
                    style={{
                        width: '50px',
                        marginBottom: '.5em',
                    }}
                />
                <div
                    className={LOADING_SKELETON_CLASS}
                    style={{
                        width: '400px',
                        marginBottom: '.5em',
                    }}
                />
                {/* Min, max prices */}
                <div
                    className={'d-flex justify-content-between align-items-center'}>
                    <div
                        className={LOADING_SKELETON_CLASS}
                        style={{ width: '50px' }}
                    />
                    <div
                        className={LOADING_SKELETON_CLASS}
                        style={{ width: '50px' }}
                    />
                </div>
            </div>
            <div>
                {/* Vendor */}
                <div
                    className={LOADING_SKELETON_CLASS}
                    style={{
                        width: '100px',
                        marginBottom: '.5em',
                        marginLeft: 'auto',
                    }}
                />
                <div
                    className={'d-flex justify-content-between'}>
                    {/* Sort by */}
                    <div
                        className={LOADING_SKELETON_CLASS}
                        style={{
                            width: '240px',
                            marginRight: '.5em',
                        }}
                    />
                    {/* Limit */}
                    <div
                        className={LOADING_SKELETON_CLASS}
                        style={{ width: '100px' }}
                    />
                </div>
            </div>
        </div>
    );
}

SearchPageSidebarSkeleton.propTypes = {};